import React, {Component} from "react";
import { make_request } from "../../Utils/Utils";
import ReCAPTCHA from "react-google-recaptcha";
import autoattend from "../../../Assets/img/auto_attend_logo.png";
import hastag from "../../../Assets/img/logo_hastag.png";

const contact_recaptcha_ref = React.createRef();

class ContactForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      business_name: '',
      mobile: '',
      email: '',
      validation_alert: false,
      validation_success: false
    };
  }

  handle_change = (event) => {
    this.setState({[event.target.name]: event.target.value});
  }

  resetCaptcha = () => {
    contact_recaptcha_ref.current.reset();  
  }

  onSubmit = async () => {
    const recaptcha_response = await contact_recaptcha_ref.current.executeAsync();
    if(!!recaptcha_response) {
      this.setState({validation_alert : false, validation_success : false})
      let responseJson = await make_request({
        path: 'contact_us',
        method: 'POST',
        content: 'JSON',
        body: {query_contact: {
          name: this.state.name,
          business_name: this.state.business_name,
          mobile: this.state.mobile,
          email: this.state.email,
          contact_type: (this.props.title === "BECOME A SPONSOR") ? "become_sponsor" : "private_puzzled"
        }, recaptcha_response: recaptcha_response}
      });
      if (responseJson) {
        this.setState({validation_success : true})
      } else {
        this.setState({validation_alert : true})
      }
    }
  }

  render() {
    const {title, button_name} = this.props;
    return (
      <div>
        <form onSubmit={this.onSubmit} className="needs-validation">
          <div className="sponsor_form">
            <h5 className="mb-3 text-center">{title}</h5>
            <div className="col">
              <input
                type="text"
                className="form-control"
                placeholder="Name *"
                name="name"
                value={this.state.name}
                onChange={this.handle_change}
              />
            </div> <br/>

            <div className="col">
              <input
                type="text"
                className="form-control"
                placeholder="Business Name *"
                name="business_name"
                value={this.state.business_name}
                onChange={this.handle_change}
              />
            </div> <br/>
            <div className="col">
              <input
                type="number"
                className="form-control"
                placeholder="Mobile *"
                name="mobile"
                value={this.state.mobile}
                onChange={this.handle_change}
              />
            </div> <br/>
            <div className="col">
              <input
                type="text"
                className="form-control"
                placeholder="Email address *"
                name="email"
                value={this.state.email}
                onChange={this.handle_change}
              />
            </div> <br/>

            <ReCAPTCHA
              ref={contact_recaptcha_ref}
              size="invisible"
              sitekey={process.env.REACT_APP_GOOGLE_SITE_KEY}
              onChange={this.resetCaptcha}
            />
            <button
             type="button"
             onClick={this.onSubmit}
             className="btn btn-yellow">
              {button_name}
            </button> <br/> 

            <div className="action_msg mb-2 mt-2 text-center">
              {
                this.state.validation_alert  &&
                <p className="error"> Enter the fields correctly </p>
              }

              {
                this.state.validation_success  &&
                <p> Thanks for contacting us. We will be in touch soon </p> 
              } 
            </div>
          </div>
        </form>
      </div>
    );
  }
}

function sponsor_section(title) {
  return(
    <div>
      <h3 className="mt-5 text-center sponsor_head">{title}</h3>
      <div className="row mt-5 mb-3 powered_by">
        <div className="col-md-2 offset-md-4">
          <a href="https://autoattend.com/" target="_blank" rel="noopener noreferrer"> <img src={autoattend} alt="" />  </a>
        </div>
        <div className="col-md-2">
          <a href="https://www.hashtagtechnologies.com/" target="_blank" rel="noopener noreferrer"> <img src={hastag} alt="" /> </a>
        </div>
      </div>
    </div>
  );
}

export { ContactForm, sponsor_section };
